// alterar arquivo: public/index.html

// checar se existe código do google analytics (apagar ou substituir se for o caso)

// alterar arquivos: .firebaserc (conferir nesse se o default e target apontam para o projeto correto do firebase), firebase.json, package.json e info.txt com o nome do projeto no firebase

// color primary: public/assets/switcher/css/color2.css
// color secondary: public/assets/switcher/css/color2.css: 135

export const id_firebase = "cw2cfh9Jnm0EHWcDg1S5";  // Shopping


export const ids_firebase = [ 
    "2Jc5Cv0NmR0zoJKOD7mE", // Maverick 0
    "10hrB73mIdmXp5QWKOhK",  // Pissarelli 1
    "zhh1I1SMta8uxCkyRM9M",   // Gdr 2
    "uLYQKAJn5Ke8T0s1u1jW",  // Spiner 3
    "B22Ytprlwtq4o0XSS8BR",// La Voiture 4
    "btIorHtmK38AqgXEzsDy", // 99 Veiculos 5
    "AJaxwEeyRHFT0mJSXszX", // Canever 6
    "5zX8Xl5nCj9oFDhK3bYy", // AutoD 7
    "hyhfmgAOJkiCl8N8yiPO", // Zion Motors 8
];

    export const href_revenda = [
        "veiculo_maverick",
        "veiculo_pissarelli",
        "veiculo_gbr",
        "veiculo_spiner",
        "veiculo_lavoiture",
        "veiculo_99veiculos",
        "veiculo_canever",
         "veiculo_autod",
         "veiculo_zion"
    ];
    